import { Pencil, RefreshCw, Users } from "lucide-react";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import Corretor from "../model/Corretor";
import { useToastContext } from "../provider/ToastContext";
import CorretorService from "../service/administracao/CorretorService";
import EditarCorretorDialog from "./dialog/EditarCorretorDialog";

const corretorService = new CorretorService();

export default function CorretoresComponent() {
    const [corretores, setCorretores] = useState<Corretor[]>([]);
    const [corretorSelecionado, setCorretorSelecionado] = useState<Corretor | null>(null);
    const [dialogVisivel, setDialogVisivel] = useState(false);
    const [sincronizando, setSincronizando] = useState(false);
    const { msgErro, msgSucesso } = useToastContext();

    const carregar = () => {
        corretorService.buscarTodos()
            .then(setCorretores)
            .catch((erro) => {
                msgErro("Erro ao carregar corretores", erro?.data?.message || "Tente novamente mais tarde.");
            });
    };

    useEffect(() => {
        carregar();
    }, []);

    const sincronizar = () => {
        setSincronizando(true);
        corretorService.integrar()
            .then(() => {
                msgSucesso("Corretores sincronizados", "A sincronização foi concluída com sucesso.");
                carregar();
            })
            .catch((erro) => {
                msgErro("Erro ao sincronizar corretores", erro?.data?.message || "Tente novamente mais tarde.");
            })
            .finally(() => setSincronizando(false));
    };

    const acoesTemplate = (corretor: Corretor) => (
        <Button
            icon={<Pencil size={16} />}
            label="Editar"
            outlined
            className="p-button-sm"
            onClick={() => {
                setCorretorSelecionado(corretor);
                setDialogVisivel(true);
            }}
        />
    );

    const header = (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div className="flex align-items-center gap-2">
                <Users size={24} style={{ color: "var(--primary-color)" }} />
                <h5 className="m-0">Gerenciamento de Corretores</h5>
            </div>
        </div>
    );

    return (
        <div>
            <EditarCorretorDialog
                corretor={corretorSelecionado}
                visible={dialogVisivel}
                onHide={() => setDialogVisivel(false)}
                onConfirm={() => {
                    setDialogVisivel(false);
                    setCorretorSelecionado(null);
                    carregar();
                    msgSucesso("E-mail atualizado", "O e-mail do corretor foi atualizado com sucesso.");
                }}
            />

            <div className="mb-4">
                <h2>Corretores</h2>
                <p className="text-muted">Gerencie os corretores e seus e-mails de contato</p>
            </div>

            <Card>
                <DataTable
                    header={header}
                    value={corretores}
                    dataKey="id"
                    paginator
                    rows={10}
                    rowsPerPageOptions={[10, 25, 50]}
                    stripedRows
                    emptyMessage="Nenhum corretor encontrado."
                >
                    <Column field="nome" header="Nome" sortable />
                    <Column field="email" header="E-mail" sortable />
                    <Column header="Ações" body={acoesTemplate} style={{ textAlign: "right", width: "140px" }} />
                </DataTable>
            </Card>
        </div>
    );
}
